import * as React from "react";

import Fuse from "fuse.js";
import _ from "lodash";
import { connect } from "react-redux";

import { Badge, SearchInput, LineSwitcherItem, Switcher } from "@similarweb/ui-components";

import { EFamilyTypes } from "app/components/dashboard/dashboard-templates/components/DashboardTemplatesTypes";
import DashboardService from "app/components/dashboard/services/DashboardService";
import widgetSettings from "app/components/dashboard/WidgetSettings";
import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";

import WidgetWizardCard from "./WidgetWizardCard";
import { Box } from "@similarweb/ui-components/foundations";

class StatefullLineSwitcher extends React.PureComponent<any, any> {
    public static getDerivedStateFromProps(props, state) {
        if (props.selected !== state.selected) {
            return {
                selected: props.selected,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected || 0,
        };
    }

    public onItemClicked = (item) => {
        const { items } = this.props;
        const trackingEvent =
            items[item]?.id === SEGMENTS_FAMILY_NAME
                ? "Segment Analysis tab"
                : items[item]?.id === EFamilyTypes.RankTracker
                  ? "Rank Tracker tab"
                  : `Dashboard Family/${items[item]?.id}`;

        allTrackers.trackEvent("Switch Item", "switch", trackingEvent);

        this.props.onItemClicked(this.props.items[item]);
    };

    public render() {
        return (
            <Switcher
                customClass="LineSwitcher"
                onItemClick={this.onItemClicked}
                selectedIndex={this.state.selected}
            >
                {this.props.items.map((item, index) => (
                    <LineSwitcherItem key={index}>
                        <Box display="inline-flex" gap="4px">
                            {item.title}
                            {item?.isNew ? <Badge type="new" /> : null}
                        </Box>
                    </LineSwitcherItem>
                ))}
            </Switcher>
        );
    }
}

// let isTracked = false;
// eslint:disable-next-line: max-classes-per-file
class WidgetWizardCardsContainer extends React.PureComponent<any, any> {
    private allWidgetMetrics;

    private isTracked = false;

    constructor(props) {
        super(props);
        const dashboardFamilies = [
            { id: "All", title: i18nFilter()(`dashboard.metricGallery.filters.all`) },
            { id: "Website", title: i18nFilter()(`dashboard.metricGallery.filters.website`) },
            {
                id: "Segments",
                title: i18nFilter()(`dashboard.metricGallery.filters.segments`),
                isNew: true,
            },
            { id: "Industry", title: i18nFilter()(`dashboard.metricGallery.filters.industry`) },
            { id: "Keyword", title: i18nFilter()(`dashboard.metricGallery.filters.keyword`) },
            { id: "Mobile", title: i18nFilter()(`dashboard.metricGallery.filters.apps`) },
            {
                id: "RankTracker",
                title: i18nFilter()(`dashboard.metricGallery.filters.RankTracker`),
                isNew: true,
            },
        ].filter(DashboardService.validateDashboardFamily);

        this.allWidgetMetrics = widgetSettings.getWidgetMetrics().map((metric) => {
            metric.translatedText = i18nFilter()(`dashboard.metricGallery.${metric.family}.${metric.id}.title`);
            metric.translatedDescription = i18nFilter()(
                `dashboard.metricGallery.${metric.family}.${metric.id}.description`,
            );
            return metric;
        });
        this.allWidgetMetrics = _.sortBy(this.allWidgetMetrics, (metric: any) => {
            const prefix = metric.isDisabled ? "" : "_";
            return prefix + metric.translatedText.toLowerCase();
        });

        this.state = {
            isGalleryNav: true,
            metrics: this.allWidgetMetrics,
            selectedMetric: -1,
            searchPhrase: "",
            selectedFamilyItem: {
                id: props.dashboardWizard.widget.family || "Website",
                text: props.dashboardWizard.widget.family || "Website",
            },
            selectedFamilyIndex:
                _.findIndex(dashboardFamilies, {
                    id: props.dashboardWizard.widget.family || "All",
                }) || 1,
            dashboardFamilies,
        };
        setTimeout(() => {
            this.handleSearch({});
        });
    }

    public switchFamily = (item) => {
        this.setState({
            selectedFamilyItem: item,
            selectedFamilyIndex: _.findIndex(this.state.dashboardFamilies, { id: item.id }),
        });
        setTimeout(() => {
            this.handleSearch({});
        });
    };

    public onSearchBlur = () => {
        this.setState({
            isGalleryNav: false,
        });
    };

    public selectNextFamilyItem = () => {
        const familyItemsCount = this.state.dashboardFamilies.length;
        let familyIndex = _.findIndex(this.state.dashboardFamilies, {
            id: this.state.selectedFamilyItem.id,
        });
        if (familyIndex === familyItemsCount - 1) {
            familyIndex = 0;
        } else {
            familyIndex++;
        }
        this.setState({
            selectedFamilyItem: this.state.dashboardFamilies[familyIndex],
            selectedFamilyIndex: familyIndex,
        });
        setTimeout(() => {
            this.handleSearch({});
        });
    };

    private onCardHover = (key, e?) => {
        if (!this.state.isGalleryNav) {
            this.setState({ selectedMetric: key });
        }
    };

    private handleSearch = (e) => {
        let searchPhrase: string;
        if (e.target) {
            searchPhrase = e.target.value;
            if (searchPhrase === this.state.searchPhrase) {
                return;
            }
            this.setState({ searchPhrase: e.target.value });
        } else {
            searchPhrase = this.state.searchPhrase;
        }

        switch (e.key) {
            default:
                this.setState({ selectedMetric: 0 });
                const value = searchPhrase;
                const searchOptions = {
                    shouldSort: true,
                    threshold: 0.5,
                    location: 0,
                    distance: 100,
                    maxPatternLength: 32,
                    minMatchCharLength: 0,
                    keys: ["translatedText", "translaytedDescription"],
                };
                const fuse = new Fuse(this.allWidgetMetrics, searchOptions);
                let filtered = value !== "" ? fuse.search(value) : this.allWidgetMetrics;
                if (this.state.selectedFamilyItem.id !== "All") {
                    filtered = filtered.filter((item) => item.family === this.state.selectedFamilyItem.id);
                }
                this.setState({ metrics: filtered });
        }
    };

    private emptySearch = (val) => {
        if (val === "") {
            this.setState({ searchPhrase: "" });
            setTimeout(() => {
                this.handleSearch({});
            });
        }
    };

    private handleGalleryNavigation = (e) => {
        this.setState({ isGalleryNav: true });
        switch (e.key) {
            case "Tab": {
                e.preventDefault();
                this.selectNextFamilyItem();
                break;
            }
            case "ArrowDown":
                this.setState((prevState) => {
                    if (this.state.selectedMetric >= this.state.metrics.length) {
                        return {
                            selectedMetric: 0,
                        };
                    }
                    if (this.state.selectedMetric === -1) {
                        return {
                            selectedMetric: 0,
                        };
                    }
                    return {
                        selectedMetric: prevState.selectedMetric + 2,
                    };
                });
                break;
            case "ArrowUp":
                this.setState((prevState) => {
                    if (this.state.selectedMetric <= 0) {
                        return {
                            selectedMetric: 0,
                        };
                    }
                    return {
                        selectedMetric: prevState.selectedMetric - 2,
                    };
                });
                break;
            case "ArrowLeft":
                this.setState((prevState) => {
                    if (this.state.selectedMetric <= 0) {
                        return {
                            selectedMetric: 0,
                        };
                    }
                    return {
                        selectedMetric: prevState.selectedMetric - 1,
                    };
                });
                break;
            case "ArrowRight":
                if (this.state.selectedMetric >= this.state.metrics.length) {
                    return {
                        selectedMetric: 0,
                    };
                }
                this.setState((prevState) => {
                    return {
                        selectedMetric: prevState.selectedMetric + 1,
                    };
                });
                break;
            case "Enter":
                this.handleCardClick(this.state.metrics[this.state.selectedMetric]);
                break;
        }
    };

    private handleCardClick = (widgetMetric, e?) => {
        const searchPhrase = this.state.searchPhrase ? `/${this.state.searchPhrase}` : "";
        this.props.onCardClick(widgetMetric);
        const { family, translatedText } = widgetMetric;

        if (!this.isTracked) {
            const trackingEvent =
                family === SEGMENTS_FAMILY_NAME
                    ? `Segment Analysis Metrics/${translatedText}`
                    : family === EFamilyTypes.RankTracker
                      ? `Rank Tracker Metric/${translatedText}`
                      : `metric${searchPhrase}`;

            allTrackers.dispatchTrackEvent("Search Bar", "click", trackingEvent);

            this.isTracked = true;
        }
    };

    componentWillUnmount(): void {
        this.isTracked = false;
    }

    private calculateScrollPositionByIndex(index) {
        if (this.state.isGalleryNav) {
            let internalIndex = index;
            if (internalIndex < 2) {
                return $(".DashboardParentContainer").scrollTop(0);
            }
            if (!this.isCardFullyViewable(index)) {
                if (internalIndex % 2 === 0) {
                    internalIndex = internalIndex + 1;
                }
                $(".DashboardParentContainer").scrollTop(internalIndex * 136 - 280);
            }
        }
    }

    private isCardFullyViewable(index) {
        const pageTopToCardBottom =
            $($(".react-wizard-cards-container-card")[index]).offset()?.top +
            $(".react-wizard-cards-container-card")[index]?.scrollHeight;
        const scrolledPlusViewable =
            $(".DashboardParentContainer").scrollTop() +
            $(".DashboardParentContainer").height() -
            $(".DashboardParentContainer").offset()?.top;

        if (
            $($(".react-wizard-cards-container-card")[index]).offset()?.top >
                $(".DashboardParentContainer").scrollTop() &&
            pageTopToCardBottom < scrolledPlusViewable
        ) {
            return true;
        } else {
            return false;
        }
    }

    public render() {
        this.calculateScrollPositionByIndex(this.state.selectedMetric);
        return (
            <div className="react-wizard">
                <div className="react-wizard-filter">
                    {/*todo: i18n */}
                    <StatefullLineSwitcher
                        items={this.state.dashboardFamilies}
                        selected={this.state.selectedFamilyIndex}
                        onItemClicked={this.switchFamily}
                    />
                    <SearchInput
                        isFocused={true}
                        placeholder="Search"
                        className="react-wizard-filter-input"
                        onKeyUp={this.handleSearch}
                        onBlur={this.onSearchBlur}
                        onChange={this.emptySearch}
                        onKeyDown={this.handleGalleryNavigation}
                    />
                </div>
                {this.state.metrics.length > 0 ? (
                    <ul className="react-wizard-cards-container">
                        {this.state.metrics.map((widgetMetric, key) => {
                            let _cardClassNames = `react-wizard-cards-container-card`;
                            let _buttonText = `dashboard.metricGallery.metricButtonText`;
                            if (widgetMetric.isDisabled) {
                                _cardClassNames = `react-wizard-cards-container-card react-wizard-cards-container-card--disabled`;
                                _buttonText = `dashboard.metricGallery.metricButtonText.upgrade`;
                            }
                            return (
                                <WidgetWizardCard
                                    isGalleryNav={this.state.isGalleryNav}
                                    onClick={(e) => this.handleCardClick(widgetMetric, e)}
                                    onMouseOver={(e) => this.onCardHover(key, e)}
                                    className={_cardClassNames}
                                    key={key}
                                    isSelected={key === this.state.selectedMetric}
                                    isDisabled={widgetMetric.isDisabled}
                                    title={widgetMetric.translatedText}
                                    description={widgetMetric.translatedDescription}
                                    buttonText={_buttonText}
                                    imageUrl={AssetsService.assetUrl(
                                        `/Images/dashboard/metrics/${widgetMetric.id}.png`,
                                    )}
                                />
                            );
                        })}
                    </ul>
                ) : (
                    <div className={"react-wizard-filter--empty"}>
                        <h4>
                            <I18n>dashboard.metricGallery.empty.title</I18n>
                        </h4>
                        <h5>
                            <I18n>dashboard.metricGallery.empty.subtitle</I18n>
                        </h5>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps({ customDashboard: { dashboardWizard } }) {
    return {
        dashboardWizard,
    };
}

const connectedComponent = connect(mapStateToProps)(WidgetWizardCardsContainer);

export default connectedComponent;
